"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FlexPane_1 = require("./components/FlexPane");
exports.hideFlexPane = FlexPane_1.hideFlexPane;
exports.mountAndShowFlexPane = FlexPane_1.mountAndShowFlexPane;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-flex-pane/lib/lazyIndex.js
// module id = 2920
// module chunks = 98